<template>
  <div v-loading="showFlag">
    <!--  納品異常処理画面 -->
    <t-card>
      <div>
        <t-row>
          <t-col :span="24" class="right">
            <!-- 赤伝票出力 -->
            <t-button
              round
              type="primary"
              class="dialogButton_180_40"
              :disabled="redTicketBtnFlg"
              ref="outputBtn"
              @click="outputExcel"
            >
              <i class="el-icon-download"></i>
              {{ $t("resource.SEND.RED_DATE_OUTPUT") }}
            </t-button>
          </t-col>
        </t-row>
        <t-row class="marginBottom">
          <t-col :span="24">
            <!-- テーブル -->
            <div>
              <t-table
                ref="sendErrorTable"
                :data="sendErrorTable"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                highlight-current-row
                @cell-click="editCellData"
                :cell-class-name="tableCellClassName"
                :row-class-name="rowClassName"
                border
                fit
              >
                <!-- テーブルの列 -->

                <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 画面と文字サイズの調整 -->
                <!-- <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                > -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="`${column.class} input_font_small`"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                  <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                  <template slot-scope="scope">
                    <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
                    <!-- <t-input-number
                      v-if="
                        column.prop != 'sdCloseState' &&
                        column.prop != 'sdRemarks' &&
                        editableColumns.includes(column.prop)
                      "
                      class="cell_input_number"
                      :controls="false"
                      :precision="0"
                      :min="0"
                      :max="999999"
                      v-model="scope.row[column.prop]"
                      @change="changeCellData()"
                      :ref="`input${scope.row.index}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                    ></t-input-number>
                    <t-input
                      maxLength="200"
                      v-else-if="column.prop == 'sdRemarks'"
                      v-model="scope.row[column.prop]"
                      :ref="`input${scope.row.index}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                    ></t-input> -->

                    <t-input-number
                      v-if="
                        column.prop != 'sdCloseState' &&
                        column.prop != 'sdRemarks' &&
                        editableColumns.includes(column.prop)
                      "
                      class="cell_input_number cell_input_font_small"
                      :controls="false"
                      :precision="0"
                      :min="0"
                      :max="99999"
                      v-model="scope.row[column.prop]"
                      :ref="`input${scope.row.index}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                      @focus="selectValue($event)"
                      @blur="handleBlur(scope.row, column.prop)"
                    >
                      <!-- @change="changeCellData"-->
                    </t-input-number>

                    <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                    <!-- 課題_備考機能の追加 -->
                    <!-- <t-input
                      maxLength="200"
                      v-else-if="column.prop == 'sdRemarks'"
                      v-model="scope.row[column.prop]"
                      :ref="`input${scope.row.index}`"
                      class="cell_input_font_small"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                      @focus="selectValue($event)"
                    ></t-input> -->
                    <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                    <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->

                    <t-checkbox
                      v-model="scope.row['sdCloseStateBool']"
                      v-else-if="column.prop == 'sdCloseState'"
                      :disabled="
                        scope.row['sdDeliveryNgQty'] === 0 ||
                        !scope.row['sdDeliveryNgQty']
                      "
                    />
                    <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                    <!-- 納期、注番の変更(見積単位⇒製品単位に変更) -->
                    <t-date-picker
                      v-else-if="cusDeliveryDateInputProc(scope.row, column)"
                      v-model="scope.row[column.prop]"
                      class="dialogDate cell_input_font_small"
                      :clearable="false"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :show-icon="false"
                    >
                    </t-date-picker>
                    <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                    <span v-else>
                      {{ scope.row[column.prop] }}
                    </span>
                  </template>
                </t-table-column>

                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_備考機能の追加 -->
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                <!-- <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  :class-name="'cell_txt_center input_font_small'"
                  :min-width="100"
                >
                  <template slot-scope="scope">
                    <div class="button-container">
                      <t-tooltip placement="bottom" effect="light">
                        <div
                          slot="content"
                          class="tooltip-content"
                          v-html="
                            formatRemarksShowProc(scope.row.aodProdRemarksSum)
                          "
                        ></div>
                        <t-button
                          :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                          icon="el-icon-search"
                          size="small"
                          circle
                        >
                        </t-button>
                      </t-tooltip>
                      <t-button
                        type="warning"
                        icon="el-icon-edit"
                        size="small"
                        circle
                        @click="addRemarksProd(scope.row, $event)"
                      ></t-button>
                    </div>
                  </template>
                </t-table-column> -->
                <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  prop="aodProdRemarksSum"
                  :class-name="'cell_txt_center input_font_small'"
                  :width="getRemarksColumnWidthProc()"
                >
                  <template slot-scope="scope">
                    <div class="bikouDiv">
                      <!-- 備考表示 -->
                      <span class="bikouText">
                        {{ scope.row.aodProdRemarksSum }}
                      </span>
                      <!-- 備考編集 -->
                      <t-button
                        type="warning"
                        icon="el-icon-edit"
                        size="small"
                        class="bikouButton"
                        circle
                        @click="showRemarksDialogProc(scope.row, $event)"
                      ></t-button>
                    </div>
                  </template>
                </t-table-column>
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>

      <div :style="{ height: bottomHeight + 'px' }">
        <t-form label-position="right">
          <t-row type="flex" justify="end">
            <div>
              <t-col :span="24">
                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  ref="confirmBtn"
                  @click="confirmClick"
                >
                  <i class="el-icon-check"></i>
                  {{ $t("resource.sys.sure") }}</t-button
                >
              </t-col>
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { getUserInfo } from "@/auth";
import { t } from "@/locales";
import {
  outputExcelToZip,
  showRemarksDialog,
  showRemarksUpdDialog,
} from "@/services/common";
import {
  getAcceptOrderAndOrderDetail,
  saveSendErrorData,
  searchSendDetailByNo,
} from "@/services/send";
import {
  cmpDetailDataExceptRemarks,
  formatDateStrToString,
  formatDateToString,
  formatRemarksShow,
  formatStringToCurrency,
  getDialogContentHeight,
  getIconType,
  getRemarksColumnWidth,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  NUM_ZERO,
  STR_EMPTY,
  STR_ONE,
  STR_TWO,
  STR_ZERO,
} from "@/utils/const";
import { Message, Modal } from "@tellus/component";

export default {
  data() {
    return {
      //出荷異常情報
      sendErrorTable: [
        {
          sdQuoteNo: "", // 見積No
          sdProdNo: "", // 受注明細No
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          //aobCusDeliveryDate: "", //得意先納期
          aodCusDeliveryDate: "", //得意先納期
          aodCusDeliveryDateHistory: "", //得意先納期履歴
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          aodProdName: "", // 品名
          aodProdDrawNo: "", // 図番,
          aodProdQuantity: "", //受注数量
          aodProdUnit: "", // 単位
          sdSendQty: "", //出荷数
          sdDeliveryNgQty: "", //出荷NG数
          sdUSalesPrice: "", //売価
          sdTotalSales: "", //小計
          aobAcceptDate: "", //受注日
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          //aobCusOrderNo: "", //注番
          aodCusOrderNo: "", //注番
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          sdCloseState: "", //クローズ状態
          // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 課題_備考機能の追加
          // sdRemarks: "", //備考
          // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          sdOrderNo: "", //注文No
          sdDetailNo: "", //注文明細No
          sdProdSuppPayQty: "", //補足支払数
          sdProdExKbn: "",
        },
      ],

      saveOrderDetailForm: [
        {
          odOrderNo: "", // 注文No.
          odOrderDetailNo: "", //注文明細No.
          odUPrice: "", //加工単価(CNY)
          odTotal: "", //小計
          odProdQuantity: "", //数量
          odCurType: "", // 貨幣タイプ
          odExr: "", //レート
          odMaterialCost: "", //材料費
          odMachineCost: "", //加工費
          odProcess1Cost: "", //処理1費用
          odProcess2Cost: "", //処理2費用
          odProcess3Cost: "", //処理3費用
          odProcess4Cost: "", //処理4費用
          odPayStatus: "", //支払状態
          odProdExKbn: "", //製品異常区分
          odProdExQty: "", //異常件数
          odProdCloseQty: "", //クローズ件数
          odProdSuppQty: "", //補足件数
          odProdSuppPayQty: "", //補足支払数
          odCloseState: "", //クローズ状態
          odQuoteNo: "", //受注基本情報_見積No
          odProdNo: "", //受注明細_受注明細No
          odUpdateUser: "", //更新者
        },
      ],

      saveAcceptOrderForm: [
        {
          aodQuoteNo: "", // 見積No.
          aodProdNo: "", //受注明細No.
          aodProdName: "",
          aodProdDrawNo: "",
          aodProdQuantity: "",
          aodProdUnit: "",
          aodProdMaterial: "",
          aodProdTreatment: "",
          aodUWeight: "",
          aodMSupCode: "",
          aodMSupDate: "",
          aodMCurType: "",
          aodMExr: "",
          aodMUPrice: "",
          aodMTransportCost: "",
          aodMUTransportCost: "",
          aodMCommissionRate: "",
          aodMUCommission: "",
          aodMUPurchasePrice: "",

          aodP1SupCode: "",
          aodP1SupDate: "",
          aodP1CurType: "",
          aodP1Exr: "",
          aodP1UPrice: "",
          aodP1TransportCost: "",
          aodP1UTransportCost: "",
          aodP1CommissionRate: "",
          aodP1UCommission: "",
          aodP1UPurchasePrice: "",

          aodP2SupCode: "",
          aodP2SupDate: "",
          aodP2CurType: "",
          aodP2Exr: "",
          aodP2UPrice: "",
          aodP2TransportCost: "",
          aodP2UTransportCost: "",
          aodP2CommissionRate: "",
          aodP2UCommission: "",
          aodP2UPurchasePrice: "",

          aodP3SupCode: "",
          aodP3SupDate: "",
          aodP3CurType: "",
          aodP3Exr: "",
          aodP3UPrice: "",
          aodP3TransportCost: "",
          aodP3UTransportCost: "",
          aodP3CommissionRate: "",
          aodP3UCommission: "",
          aodP3UPurchasePrice: "",

          aodGrossMargin: "",
          aodUSalesPrice: "",
          aodUSetPrice: "",
          aodUGrossProfit: "",
          aodTotPurchasePrice: "",
          aodTotSalesPrice: "",
          aodTotWeight: "",
          aodProdExKbn: "",
          aodProdExQty: "",
          aodProdCloseQty: "",
          aodProdSuppQty: "",
          aodCloseState: "",
          aodUpdateUser: "",
        },
      ],

      //注文明細データ
      OrderDetailForm: [],
      //
      AcceptOrderDetailForm: [],
      //最大高さ
      maxheight: 260,

      //テーブルの列
      columns: [
        {
          // 見積No.
          prop: "sdQuoteNo",
          label: t("resource.SEND.ESTIMATED_NO"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 得意先納期
        {
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          //prop: "aobCusDeliveryDate",
          prop: "aodCusDeliveryDate",
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
          label: t("resource.SEND.CUS_DELIVERY_DATE"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.tableCommon.width200"),
          width: t("widgetSize.tableCommon.width160"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_center",
        },
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // 得意先納期履歴
        {
          prop: "aodCusDeliveryDateHistory",
          label: t("resource.ACCEPT_ORDER.AOD_CUS_DELIVERY_DATE_HISTORY"),
          width: t("widgetSize.tableCommon.width120"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.SEND.PRODUCT_NAME"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.SEND.PRODUCT_DRAW_NO"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 受注数量
        {
          prop: "aodProdQuantity",
          label: t("resource.SEND.ACCEPT_ORDER_NUM"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.SEVENTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        // 単位
        {
          prop: "aodProdUnit",
          label: t("resource.SEND.PRODUCT_UNIT"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.SIXTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_center",
        },

        // 出荷数
        {
          prop: "sdSendQty",
          label: t("resource.SEND.SEND_COUNT"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.SEVENTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        // 出荷NG数
        {
          prop: "sdDeliveryNgQty",
          label: t("resource.SEND.SEND_NG_COUNT"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.EIGHTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        // 売価
        {
          prop: "sdUSalesPriceShow",
          label: t("resource.SEND.SALES_PRICE"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.EIGHTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        // 小計
        {
          prop: "sdTotalSalesShow",
          label: t("resource.SEND.SUBTOTAL"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // 受注日
        {
          prop: "aobAcceptDate",
          label: t("resource.SEND.ORDERED_DATE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
        // 注番
        {
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          //prop: "aobCusOrderNo",
          prop: "aodCusOrderNo",
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
          label: t("resource.SEND.CUS_ORDER_NO"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.EIGHTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // クローズ状態
        {
          prop: "sdCloseState",
          label: t("resource.SEND.SEND_CLOSE_STATUS"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.EIGHTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_center",
        },

        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // // 備考
        // {
        //   prop: "sdRemarks",
        //   label: t("resource.SEND.REMARKS"),
        //   width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      ],

      //現在選択されているセル
      currentCell: null,

      data: null,

      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_備考機能の追加
      // editableColumns: ["sdDeliveryNgQty", "sdCloseState", "sdRemarks"],
      editableColumns: ["sdDeliveryNgQty", "sdCloseState"],
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      //出荷詳細情報(データ保存用)
      sendDetailData: [],
      //「赤伝票データ作成」ボタン使用フラグ
      redTicketBtnFlg: false,
      showFlag: false,

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 1,
      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        20
      ),

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      sendEditData: this.sendEditForm,
      sendDetailTableData: this.sendDetailTable,

      // 読み込み回数
      numLoads: 1,

      // 比較用明細情報
      cmpDetailResult: {},
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 共通備考の調整（備考更新時刻）
      aodUpdateTime: null,
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
    };
  },

  props: {
    sendEditForm: {
      Type: Object,
      default: null,
    },
    sendDetailTable: {
      Type: Object,
      default: null,
    },
  },

  mounted() {
    this.init(this.sendDetailTable);

    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    //列幅に自動調整
    // setColumnWidth(this.columns, this.sendErrorTable);
    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 End↑

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        20
      );
    },

    // 初期化
    init(data) {
      this.showFlag = true;
      // this.dataInitProcess(data);
      this.searchSendDetailByNoProc();
    },

    //出荷No.による出荷詳細情報の取得
    searchSendDetailByNoProc() {
      // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      //searchSendDetailByNo({ sendBasicForm: this.sendEditData })
      //検索フラグselectFlg 　1:納品詳細画面　　2：納品異常処理画面
      searchSendDetailByNo({ sendBasicForm: this.sendEditData, selectFlg: "2" })
        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        .then((res) => {
          // 出荷編集情報を表示
          this.sendEditData = res.sendBasicForm;
          // 出荷詳細テーブル情報を表示
          this.sendDetailTableData = res.sendDetailList;
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          // 共通備考の調整（備考更新時刻）
          if (res.sendDetailList != null && res.sendDetailList.length != 0) {
            this.aodUpdateTime = res.sendDetailList[0].aodUpdateTime;
          }
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
          this.dataInitProcess(this.sendDetailTableData);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    dataInitProcess(data) {
      for (let index = 0; index < data.length; index++) {
        const item = data[index];
        if (!item.sdDeliveryNgQty) {
          item.sdDeliveryNgQty = NUM_ZERO;
        }

        if (!item.sdProdCloseQty) {
          item.sdProdCloseQty = NUM_ZERO;
        }
        item.index = index;

        if (!item.sdSendDetailNo || item.sdSendDetailNo === 0) {
          item.sdSendDetailNo = index + 1;
        }
        // 売価
        item.sdUSalesPriceShow =
          item.sdUSalesPriceShow === "-"
            ? item.sdUSalesPriceShow
            : formatStringToCurrency(item.sdUSalesPrice);
        // 小計
        item.sdTotalSalesShow =
          item.sdTotalSalesShow === "-"
            ? item.sdTotalSalesShow
            : formatStringToCurrency(item.sdTotalSales);

        //受注日が空のチェック
        if (typeof item.aobAcceptDate === "undefined") {
          item.aobAcceptDate = STR_EMPTY;
        } else {
          item.aobAcceptDate = formatDateStrToString(item.aobAcceptDate);
        }

        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // 得意先納期が空のチェック
        // if (typeof item.aobCusDeliveryDate === "undefined") {
        //   item.aobCusDeliveryDate = STR_EMPTY;
        // } else {
        //   item.aobCusDeliveryDate = formatDateStrToString(
        //     item.aobCusDeliveryDate
        //   );
        // }

        if (typeof item.aodCusDeliveryDate === "undefined") {
          item.aodCusDeliveryDate = STR_EMPTY;
        } else {
          item.aodCusDeliveryDate = formatDateStrToString(
            item.aodCusDeliveryDate
          );
        }
        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
      }

      this.sendErrorTable = data;

      // 読み込み回数 = 1
      if (this.numLoads == 1) {
        // 比較用明細情報
        this.cmpDetailResult = JSON.parse(JSON.stringify(this.sendErrorTable));
        // 読み込み回数 + 1
        this.numLoads = this.numLoads + 1;
      }

      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      //列幅に自動調整
      // setColumnWidth(this.columns, this.sendErrorTable);
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      // 列幅の調整
      this.columns = this.columns.map((col) => {
        if (col.prop === "aodCusDeliveryDate") {
          return { ...col, width: 170 };
        }
        return col;
      });
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
      this.getOrderDetailForm();
    },

    //注文明細データの取得
    getOrderDetailForm() {
      getAcceptOrderAndOrderDetail({ sendDetailList: this.sendErrorTable })
        .then((res) => {
          this.OrderDetailForm = res.orderDetailList;

          this.AcceptOrderDetailForm = res.acceptOrderDetailList;
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //确定ボタン
    confirmClick() {
      if (typeof this.$refs.confirmBtn !== "undefined") {
        // フォーカス削除
        this.$refs.confirmBtn.$el.blur();
      }

      if (!this.showFlag) {
        this.showFlag = true;
      }

      if (this.sendErrorTable) {
        // 納品NG数のチェック
        for (let index = 0; index < this.sendErrorTable.length; index++) {
          const element = this.sendErrorTable[index];
          if (
            element.sdDeliveryNgQty < 0 ||
            element.sdDeliveryNgQty > element.sdSendQty
          ) {
            let message =
              "製品「" +
              element.aodProdName +
              "」の" +
              t("message.SEND.NO_NG_CHECK");
            Modal.showWarning("", message, {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });
            this.showFlag = false;
            return;
          }
        }

        this.dataAddUpdProc();
        this.saveOrderDataProcess();
        this.saveAcceptOrderDataProcess();

        saveSendErrorData({
          sendDetailList: this.sendDetailData,
          sendBasicForm: this.sendEditData,
          acceptOrderDetailList: this.saveAcceptOrderForm,
          orderDetailList: this.saveOrderDetailForm,
        })
          .then((res) => {
            this.numLoads = 1;
            Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
            this.searchSendDetailByNoProc();
            // this.$emit("ok");
          })
          .catch((err) => {
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            } else {
              Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
            }
          })
          .finally(() => {
            this.showFlag = false;
          });
      } else {
        Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
        this.showFlag = false;
        // this.$emit("ok");
      }
      // this.$emit("ok");
    },

    // 更新されたデータ処理
    dataAddUpdProc() {
      // 更新者
      this.sendEditData.sbUpdateUser = getUserInfo().UserId;

      this.sendDetailData = this.sendErrorTable;
      for (let index = 0; index < this.sendErrorTable.length; index++) {
        const element = this.sendErrorTable[index];

        // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        for (let i = 0; i < this.sendDetailTable.length; i++) {
          const sendElement = this.sendDetailTable[i];
          // 手配NO.、手配明細NO.、見積NO.受注明細No.のチェック
          if (
            element.sdSendNo === sendElement.sdSendNo &&
            element.sdSendDetailNo === sendElement.sdSendDetailNo &&
            (element.sdOrderNo !== sendElement.sdOrderNo ||
              element.sdDetailNo !== sendElement.sdDetailNo ||
              element.sdQuoteNo !== sendElement.sdQuoteNo ||
              element.sdProdNo !== sendElement.sdProdNo)
          ) {
            element.sdOrderNo = sendElement.sdOrderNo; // 手配NO.
            element.sdDetailNo = sendElement.sdDetailNo; //手配明細NO.
            element.sdQuoteNo = sendElement.sdQuoteNo; // 見積NO.
            element.sdProdNo = sendElement.sdProdNo; //受注明細No.
          }
          // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          element.sdSendNo = this.sendEditData.sbSendNo; // 出荷No.
          element.sdSendDetailNo = index + 1; // 出荷明細No.
          // var sdTotalSales;
          // // 小計
          // if (element.sdTotalSales == STR_HYPHEN) {
          //   sdTotalSales = NUM_ZERO;
          // } else {
          //   sdTotalSales = element.sdTotalSales;
          // }
          element.sdCloseState = element.sdCloseStateBool ? 1 : 0; // クローズ状態 0：未クローズ、1：クローズ
          // element.sdTotalSales = sdTotalSales; // 小計
          // ADD 2025/04/02 ZLL 課題_250401顧客からの改善したい点への対応 start↓
        }
        // ADD 2025/04/02 ZLL 課題_2500401顧客からの改善したい点への対応 end↑
      }
    },

    // 納品NG数のチェック
    checkAllDeliveryNgQtyEmpty(table) {
      let allEmpty = true;
      for (let i = 0; i < table.length; i++) {
        if (table[i].sdDeliveryNgQty !== 0 && table[i].sdDeliveryNgQty !== "") {
          allEmpty = false;
          break;
        }
      }
      return allEmpty;
    },

    //保存された注文データ処理
    saveOrderDataProcess() {
      for (let index = 0; index < this.sendErrorTable.length; index++) {
        const element = this.sendErrorTable[index];

        this.saveOrderDetailForm = this.OrderDetailForm;
        for (let j = 0; j < this.OrderDetailForm.length; j++) {
          const detailElement = this.OrderDetailForm[j];

          //if (
          // element.sdOrderNo == detailElement.odOrderNo &&
          // detailElement.odOrderDetailNo == element.sdDetailNo
          //) {

          if (
            element.sdQuoteNo == detailElement.odQuoteNo &&
            detailElement.odProdNo == element.sdProdNo
          ) {
            // 注文数量
            detailElement.odProdQuantity = NUM_ZERO;
            detailElement.odPayStatus = STR_ONE; //支払状態：未支払
            detailElement.odProdExKbn = STR_TWO; //製品異常区分：納品異常
            detailElement.odProdExQty = element.sdDeliveryNgQty; //異常件数
            if (element.sdCloseStateBool) {
              detailElement.odProdCloseQty = element.sdDeliveryNgQty; //クローズ件数
            } else {
              detailElement.odProdCloseQty = NUM_ZERO;
            }

            detailElement.odProdSuppQty = NUM_ZERO; //補足件数
            detailElement.odProdSuppPayQty = NUM_ZERO; //補足支払数
            detailElement.odCloseState = element.sdCloseState; //クローズ状態
            var currentDate = new Date();
            // 異常製品の提出日
            detailElement.odExCreateDate = formatDateToString(currentDate);
            // 異常製品納品No.
            detailElement.odExReceSendNo = element.sdSendNo;
            // 異常製品入荷/納品明細No.
            detailElement.odExReceSendDetailNo = element.sdSendDetailNo;
            // 異常製品支払方式  1：不要
            detailElement.odExPayMethod = STR_ONE;
            // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
            // 課題_備考機能の追加
            // 備考
            // detailElement.odRemarks = element.sdRemarks;
            // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
            // 注文書出力 0：チェックしない
            detailElement.odOrderNoteOut = STR_ZERO;
            // 支払数
            detailElement.odPayQuantity = NUM_ZERO;
            detailElement.odUpdateUser = getUserInfo().UserId;
          }
        }
      }
    },

    //保存された受注データ処理
    saveAcceptOrderDataProcess() {
      for (let index = 0; index < this.sendErrorTable.length; index++) {
        const element = this.sendErrorTable[index];

        this.saveAcceptOrderForm = this.AcceptOrderDetailForm;
        for (let j = 0; j < this.AcceptOrderDetailForm.length; j++) {
          const detailElement = this.AcceptOrderDetailForm[j];
          if (
            element.sdQuoteNo == detailElement.aodQuoteNo &&
            detailElement.aodProdNo == element.sdProdNo
          ) {
            if (element.sdCloseState == STR_ONE) {
              detailElement.aodProdCloseQty = element.sdDeliveryNgQty;
            } else {
              // クローズ件数
              detailElement.aodProdCloseQty = NUM_ZERO;
            }
            // 受注数量
            detailElement.aodProdQuantity = NUM_ZERO;
            // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
            // 納期、注番の変更(見積単位⇒製品単位に変更)
            detailElement.aodCusDeliveryDate = element.aodCusDeliveryDate; //得意先納期
            detailElement.aodCusOrderNo = element.aodCusOrderNo; //注番
            // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

            // 製品異常区分
            detailElement.aodProdExKbn = STR_TWO;
            // 異常件数
            detailElement.aodProdExQty = element.sdDeliveryNgQty;
            // 補足件数
            detailElement.aodProdSuppQty = NUM_ZERO;
            // クローズ状態
            detailElement.aodCloseState = element.sdCloseState;
            var currentDate = new Date();
            // 異常製品の提出日
            detailElement.aodExCreateDate = formatDateToString(currentDate);
            // 異常製品納品No
            detailElement.aodExSendNo = element.sdSendNo;
            // 異常製品入荷/納品明細No.
            detailElement.aodExSendDetailNo = element.sdSendDetailNo;
            // 納品数
            detailElement.aodExSendQuantity = element.sdSendQty;
            // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
            // 課題_打合状態、納期の追加
            detailElement.aodDiscussStatus = STR_ONE;
            // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
            // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
            // 課題_備考機能の追加
            // 備考
            // detailElement.aodRemarks = element.sdRemarks;
            // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
            detailElement.aodUpdateUser = getUserInfo().UserId;
          }
        }
      }
    },

    // DEL 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 start↓
    //NG数入力が空白の場合、画面に0が表示されない不具合の修正
    // checkNull(val) {
    //   if (!!!val || val == "") {
    //     val = 0;
    //   }
    //   return val;
    // },
    // DEL 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 end↑

    // 赤伝票出力
    outputExcel() {
      if (typeof this.$refs.outputBtn !== "undefined") {
        // フォーカス削除
        this.$refs.outputBtn.$el.blur();
      }

      if (this.sendErrorTable) {
        let outputForm = [];
        let outputFormIndex = 0;
        // 納品NG数のチェック
        for (let index = 0; index < this.sendErrorTable.length; index++) {
          const element = this.sendErrorTable[index];
          if (
            element.sdDeliveryNgQty < 0 ||
            element.sdDeliveryNgQty > element.sdSendQty
          ) {
            // let min = NUM_ZERO;
            // let max = element.sdSendQty;
            let message =
              "製品「" +
              element.aodProdName +
              "」の" +
              t("message.SEND.NO_NG_CHECK");
            // let targetMessage = message
            //   .replace(/\$\{min\}/g, min.toString())
            //   .replace(/\$\{max\}/g, max.toString());
            Modal.showWarning("", message, {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });
            this.showFlag = false;
            return;
          }

          if (element.sdDeliveryNgQty > 0 && element.sdCloseStateBool) {
            outputForm[outputFormIndex] = element;
            outputFormIndex++;
          }
        }
        if (outputForm && outputForm.length > 0) {
        } else {
          Modal.showWarning("", t("message.SEND.OUTPUT_NG_CHECK"), {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          this.showFlag = false;
          return;
        }

        this.dataAddUpdProc();
        this.saveOrderDataProcess();
        this.saveAcceptOrderDataProcess();
        saveSendErrorData({
          sendDetailList: this.sendDetailData,
          sendBasicForm: this.sendEditData,
          acceptOrderDetailList: this.saveAcceptOrderForm,
          orderDetailList: this.saveOrderDetailForm,
        })
          .then((res) => {
            // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
            this.numLoads = 1;
            // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
            Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
            this.outputProcess();
          })
          .catch((err) => {
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            } else {
              Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
            }
            this.showFlag = false;
            // this.$emit("ok");
          });
      } else {
        Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
        this.showFlag = false;
        // this.$emit("ok");
      }

      // this.$emit("ok");
    },

    outputProcess() {
      if (!this.showFlag) {
        this.showFlag = true;
      }
      outputExcelToZip(httpApi.OutPutSendErrExcel, {
        sbSendNo: this.sendEditData.sbSendNo,
        sbCusName: this.sendEditData.sbCusCode,
      }).finally(() => {
        this.showFlag = false;
        // this.$emit("ok");
        this.searchSendDetailByNoProc();
      });
    },

    // ADD 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 start↓
    //NG数入力が空白の場合、画面に0が表示されない不具合の修正
    handleBlur(row, prop) {
      if (row[prop] === "" || row[prop] == null) {
        this.$set(row, prop, 0);
      }
      this.changeCellData();
    },
    // ADD 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 end↑

    //セルデータの保存
    changeCellData() {
      this.currentCell = null;
      this.sendErrorTable.map((item) => {
        // DEL 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 start↓
        // NG数入力が空白の場合、画面に0が表示されない不具合の修正
        //item.sdDeliveryNgQty = this.checkNull(item.sdDeliveryNgQty);
        // DEL 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 end↑
        if (item.sdDeliveryNgQty === NUM_ZERO) {
          item.sdCloseStateBool = false;
        }

        item.sdProdExQty = item.sdDeliveryNgQty;

        // DEL 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 start↓
        // NG数入力が空白の場合、画面に0が表示されない不具合の修正
        // if (item.sdCloseStateBool) {
        //   item.sdProdCloseQty = item.sdDeliveryNgQty;
        // } else {
        //   item.sdProdCloseQty = 0;
        // }
        // DEL 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 end↑

        //NG数入力が空白の場合、画面に0が表示されない不具合の修正
        this.$set(this.sendErrorTable, item.index, item);
        // ADD 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 start↓
        return item;
        // ADD 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 end↑
      });

      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // setColumnWidth(this.columns, this.sendErrorTable);
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      // 列幅の調整
      this.columns = this.columns.map((col) => {
        if (col.prop === "aodCusDeliveryDate") {
          return { ...col, width: 170 };
        }
        return col;
      });
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
    },

    //Enter処理
    focusNextInput(index, columnProp) {
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_備考機能の追加
      // let editableColumns = ["sdDeliveryNgQty", "sdRemarks"];
      let editableColumns = ["sdDeliveryNgQty"];
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      let columnIndex = editableColumns.indexOf(columnProp);

      if (columnIndex == -1) {
        columnIndex = 0;
      }

      index = index + 1;

      if (index > this.sendErrorTable.length - 1) {
        this.$refs[`input${0}`][columnIndex].focus();
      } else {
        this.$refs[`input${index}`][columnIndex].focus();
      }
    },

    //セルデータの編集
    editCellData(row, column) {
      if (!this.editableColumns.includes(column.prop)) {
        return false;
      }

      return true;
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      //var columnEditable = ["sdDeliveryNgQty", "sdCloseState", "sdRemarks"];
      // if (
      //   columnEditable.includes(column.property) ||
      //   (column.property && column.property.toString().includes("newColumn"))
      // ) {
      //   if (
      //     column.property === "sdCloseState" &&
      //     row.sdDeliveryNgQty &&
      //     row.sdDeliveryNgQty !== 0
      //   ) {
      //     //編集可能の背景色
      //     return "bg-cell-editable";
      //   }
      //   else if (column.property !== "sdCloseState") {
      //     //編集可能の背景色
      //     return "bg-cell-editable";
      //   }
      // }

      var columnEditable = [
        "sdDeliveryNgQty",
        "sdCloseState",
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // "sdRemarks",
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        "aodCusDeliveryDate",
      ];

      if (columnEditable.includes(column.property)) {
        if (
          (column.property === "sdCloseState" ||
            column.property === "aodCusDeliveryDate") &&
          (!row.sdDeliveryNgQty || row.sdDeliveryNgQty == 0)
        ) {
          return;
        }
        //編集可能の背景色
        return "bg-cell-editable";
      } else {
        return;
      }
      // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
    },

    // 製品異常
    rowClassName({ row }) {
      if (!!row.sdProdExKbn && row.sdProdExKbn != "") {
        if (row.sdProdExKbn == 2) {
          return "textColor";
        }
      }
    },

    // ダイアログを閉じる
    onCancel() {
      if (
        // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
        // !cmpDetailData(this.cmpDetailResult, this.sendErrorTable)
        !cmpDetailDataExceptRemarks(this.cmpDetailResult, this.sendErrorTable, [
          "aodProdRemarksSum",
          "aodProdRemarks",
        ]) &&
        // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
        this.sendErrorTable.length > 0
      ) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },

    close() {
      this.$emit("cancel");
    },

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    // 入力ボックスをクリックの場合、値をすべて選択します
    selectValue(e) {
      e.target.select();
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 納期、注番の変更(見積単位⇒製品単位に変更)
    //納期コントロール
    cusDeliveryDateInputProc(row, column) {
      //納期以外の場合、何もしない
      if (column.prop !== "aodCusDeliveryDate") {
        return;
      }

      //納品NG数が0の場合、納期編集不可
      if (Number(row.sdDeliveryNgQty) == 0) {
        return;
      }
      return true;
    },
    // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    addRemarksProd(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      if (!this.showFlag) {
        this.showFlag = true;
      }
      let remarks = STR_EMPTY;
      showRemarksUpdDialog(
        this,
        row.sdQuoteNo,
        row.sdProdNo,
        row.aodProdRemarksSum
      )
        .then((res) => {
          remarks = res;
        })
        .finally(() => {
          this.numLoads = 1;
          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
          if (remarks != STR_EMPTY) {
            // //　比較用明細情報の備考を変更する
            if (this.cmpDetailResult.length > 0) {
              this.cmpDetailResult.forEach((item) => {
                // 手配NO.と手配明細NO.一致の場合、備考を変更する
                if (
                  item.sdSendNo === row.sdSendNo &&
                  item.sdSendDetailNo === row.sdSendDetailNo
                ) {
                  item.aodProdRemarksSum = remarks;
                }
              });
            }
            // 備考を更新する
            row.aodProdRemarksSum = remarks;
          }
        });
    },

    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.sendErrorTable);
    },

    //共通備考の調整（備考の表示と保存）
    showRemarksDialogProc(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      if (!this.showFlag) {
        this.showFlag = true;
      }

      showRemarksDialog(
        this,
        row.sdQuoteNo,
        row.sdProdNo,
        row.aodProdRemarksSum,
        row.aodProdRemarksSum,
        this.aodUpdateTime
      )
        .then((res) => {
          if (!this.isEmptyOrNull(res)) {
            // 備考を更新する
            row.aodProdRemarksSum = res.aodProdRemarks;
            this.aodUpdateTime = res.aodUpdateTime;
            this.$set(this.sendErrorTable, row.index, row);
          }
        })
        .finally(() => {
          this.numLoads = 1;

          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
        });
    },
    //値がNULLまたはEmptyです
    isEmptyOrNull(item) {
      if (item == undefined || item == STR_EMPTY) {
        return true;
      } else {
        return false;
      }
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
</style>
